import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import ResultLink from '../../../shared/links/ResultLink';
import ReplayLink from '../../../shared/links/ReplayLink';
import { formatDate } from '../../../utils/date';

const DateCell = (props) => {
    const isVideoAvailable = !!get(props, 'videoDetail[0].finishRaceUid');
    return (
        <div className="mp-form__dateWrapper">
            {isVideoAvailable && <ReplayLink {...props} />}
            <ResultLink
                courseName={props.courseName}
                courseUid={props.courseUid}
                raceDatetime={props.raceDatetime}
                raceInstanceUid={props.raceInstanceUid}
                raceInstanceTitle={props.raceInstanceTitle}
                className={classNames(
                    'mp-form__date',
                    !isVideoAvailable && 'mp-form__date_withoutVideo'
                )}
            >
                {formatDate(props.raceDatetime, 'DDMMM')}
                <span className="hidden-sm-down">
                    {formatDate(props.raceDatetime, 'YY')}
                </span>
            </ResultLink>
        </div>
    );
};

DateCell.propTypes = {
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceInstanceUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceInstanceTitle: PropTypes.string,
};

export default DateCell;



// WEBPACK FOOTER //
// ./src/js/human/form/components/DateCell.jsx